


<ng-template #openChildModal >
    <ng-content></ng-content>
</ng-template>
<!-- <div>
<div class="modal-header">
    <h4 class="modal-title">IPERF Settings</h4>

        <button type="button"  class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>   
   
</div>
<div class="modal-body">

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
</div>
</div> -->